import { lazy, Suspense, type ReactNode } from "react";

import { AttentionWorkspacePage } from "../attention/attention-page.js";
import { LoadingState } from "../components/states.js";
import { DashboardPage } from "../dashboard/dashboard-page.js";
import { InboxPage as InboxWorkspacePage } from "../inbox/inbox-page.js";
import { RecordsWorkspacePage } from "../records/records-page.js";
import { SetupWorkspacePage } from "../setup/setup-page.js";
import { TeamWorkspacePage } from "../team/team-page.js";
import { TasksWorkspacePage } from "../tasks/tasks-page.js";

const ReportsWorkspacePage = lazy(() =>
  import("../reports/reports-page.js").then((module) => ({
    default: module.ReportsWorkspacePage,
  })),
);
const BillingWorkspacePage = lazy(() =>
  import("../billing/billing-page.js").then((module) => ({
    default: module.BillingWorkspacePage,
  })),
);
const LoggingWorkspacePage = lazy(() =>
  import("../logging/logging-page.js").then((module) => ({
    default: module.LoggingWorkspacePage,
  })),
);
const PrivacyWorkspacePage = lazy(() =>
  import("../privacy/privacy-page.js").then((module) => ({
    default: module.PrivacyWorkspacePage,
  })),
);
const SettingsWorkspacePage = lazy(() =>
  import("../settings/settings-page.js").then((module) => ({
    default: module.SettingsWorkspacePage,
  })),
);
const BusinessDetailsPage = lazy(() =>
  import("../settings/business-page.js").then((module) => ({
    default: module.BusinessDetailsPage,
  })),
);
const DataPage = lazy(() =>
  import("../settings/data-page.js").then((module) => ({
    default: module.DataPage,
  })),
);
const DevicePage = lazy(() =>
  import("../settings/device-page.js").then((module) => ({
    default: module.DevicePage,
  })),
);

function Lazy({ children }: { children: ReactNode }) {
  return <Suspense fallback={<LoadingState />}>{children}</Suspense>;
}

export function TodayPage() {
  return <DashboardPage />;
}

export function RecordsPage() {
  return <RecordsWorkspacePage />;
}

export function AttentionPage() {
  return <AttentionWorkspacePage />;
}

export function TasksPage() {
  return <TasksWorkspacePage />;
}

export function TeamPage() {
  return <TeamWorkspacePage />;
}

export function SetupPage() {
  return <SetupWorkspacePage />;
}

export function InboxPage() {
  return <InboxWorkspacePage />;
}

export function ReportsPage() {
  return (
    <Lazy>
      <ReportsWorkspacePage />
    </Lazy>
  );
}

export function LoggingPage() {
  return (
    <Lazy>
      <LoggingWorkspacePage />
    </Lazy>
  );
}

export function NotificationsSettingsPage() {
  return (
    <Lazy>
      <SettingsWorkspacePage />
    </Lazy>
  );
}

export function PlanSettingsPage() {
  return (
    <Lazy>
      <BillingWorkspacePage />
    </Lazy>
  );
}

export function PrivacySettingsPage() {
  return (
    <Lazy>
      <PrivacyWorkspacePage />
    </Lazy>
  );
}

export function BusinessSettingsPage() {
  return (
    <Lazy>
      <BusinessDetailsPage />
    </Lazy>
  );
}

export function DataSettingsPage() {
  return (
    <Lazy>
      <DataPage />
    </Lazy>
  );
}

export function ComputerSettingsPage() {
  return (
    <Lazy>
      <DevicePage />
    </Lazy>
  );
}
